import { Eleve } from '@teetsh/app/src/types/eleves';

type PartialEleve = Eleve | Required<{ familyName: string; givenName: string }>;

function joinName(el: PartialEleve, order: string[]) {
  return order.map(key => el[key]).join(' ');
}

export function sortEleves<TEleve extends PartialEleve>(
  eleves: TEleve[],
  order: string[],
  direction?: 'ASC' | 'DESC',
): TEleve[] {
  return [...eleves].sort(
    (eleveA, eleveB) =>
      joinName(eleveA, order).localeCompare(joinName(eleveB, order)) *
      (direction === 'DESC' ? -1 : 1),
  );
}
